import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import Dropdown from "../../auxiliar/ui/Dropdown";
import { dispatchActiveClinicSave } from "../../../../store/reducers/activeClinicReducer";
import { handleSubmit } from "../../../../auxiliar/auxFunctions";

const ClinicSelectorDropdown = () => {
    const activeClinic = useSelector((state) => state.activeClinic);
    const clinics = useSelector((state) => state.auth.clinics);

    const navigate = useNavigate();
    const dispatch = useDispatch();

    if (clinics === undefined || Object.keys(clinics).length === 0) {
        return (
            <button
                className="btn btn-ghost my-0 p-0 hover:bg-primary/8 hover:text-primary transition-colors duration-200"
                onClick={handleSubmit(navigate, "/clinic/register")}
            >
                Crear Clínica
            </button>
        );
    }

    // Build dropdown items
    const getDropdownItems = () => {
        const clinicItems = Object.keys(clinics).map((key) => {
            const clinic = clinics[key];
            const isActive = activeClinic.id === key;

            return {
                key: key,
                label: clinic.name,
                active: isActive,
                onClick: (e) => {
                    e.preventDefault();
                    navigate(`/clinic/${key}`);
                    dispatchActiveClinicSave(dispatch, key, clinic.name, clinic.status);
                },
            };
        });

        return [
            ...clinicItems,
            { type: "separator" },
            {
                key: "create-clinic",
                label: "Crear Clínica",
                variant: "primary",
                onClick: () => handleSubmit(navigate, "/clinic/register")(),
            },
        ];
    };

    const trigger = (
        <div className="btn btn-ghost hover:bg-primary/8 transition-colors duration-200">
            <span className="text-base-content">
                {activeClinic.name === undefined ? "Selecciona una Clínica" : activeClinic.name}
            </span>
            <svg
                className="w-4 h-4 ml-1 text-base-content/60"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
            >
                <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M19 9l-7 7-7-7"
                />
            </svg>
        </div>
    );

    return <Dropdown trigger={trigger} items={getDropdownItems()} width="w-64" />;
};

export default ClinicSelectorDropdown;
